export default{
    msg:'',
    editar:{},
    lista:'',
    boletins:'',
    inss:'',
}